import React from 'react';
import classes from './RssIcon.module.scss';
import { ReactComponent as Rss } from './rss.svg';
import classNames from 'classnames';
import { capitalizeString } from '../../../../helpers/capitalizeString';

export type RssIconViewProps = {
  type: 'square' | 'circle';
  size: 'small' | 'medium' | 'large';
  disabled?: boolean;
};

export const RssIconView = (props: RssIconViewProps): JSX.Element => {
  const { type, size, disabled } = props;
  const componentClasses = classNames(classes[capitalizeString(type)], classes.RssIcon, {
    [classes.RssDisabled]: disabled
  });

  const wrapperClasses = classNames(
    classes.RssIconWrapper,
    [classes[capitalizeString(type)]],
    [classes[`RssIconWrapper${capitalizeString(size)}`]]
  );

  return (
    <div className={wrapperClasses}>
      <div className={componentClasses}>
        <Rss />
      </div>
    </div>
  );
};
